module.exports = __webpack_public_path__ + "static/img/car.cf04e4a8.jpg";